import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './App.css'
import './styles/global-inputs.css'

// 统一设置浏览器页签标题为 BOSIMAO 查询系统
try {
  document.title = 'BOSIMAO查询系统'
} catch {}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)


